/* =================================================================
   br-video-newsletter-cta — reduced-motion video pause.

   Same idiom as br-cta-block.js: under prefers-reduced-motion the
   background video holds its poster frame instead of playing. Only
   the video variant is gated — the static image variant renders no
   <video>, so the selector simply misses. Without JS the video plays
   natively.
   ================================================================= */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!REDUCED.matches) return;

  document.querySelectorAll('.br-video-newsletter-cta').forEach(function (section) {
    var video = section.querySelector('video.br-video-newsletter-cta__asset');
    if (!video) return;

    video.removeAttribute('autoplay');
    video.pause();
  });
})();
